module.exports = __webpack_public_path__ + "static/media/financepic2.e9be0b26.png";